






































import { defineComponent, onMounted, ref } from '@vue/composition-api'

export default defineComponent({
  setup() {
    const root = ref()
    const resizeElement = () => {
      if (root.value) {
        resizeCanvas(root.value.clientWidth, root.value.clientHeight * 0.75)
      }
    }
    let canvas = ref<HTMLCanvasElement | null>(null)
    let context = ref<CanvasRenderingContext2D | null>(null)
    let isDrag = ref(false)
    let canvasMode = ref('pen')
    let isOverClearBtn = ref(false)
    const music = new Audio()
    music.volume = 0.2
    music.src = './sound/other_sound.mp3'
    onMounted(() => {
      if (document.querySelector<HTMLCanvasElement>('#paintCanvas') !== null) {
        canvas.value = document.querySelector<HTMLCanvasElement>('#paintCanvas')
      }
      if (!canvas.value) {
        return
      }
      context.value = canvas.value.getContext('2d')
      if (!context.value) {
        return
      }
      context.value.lineCap = 'round'
      context.value.lineJoin = 'round'
      context.value.lineWidth = 5
      context.value.strokeStyle = '#000000'
      resizeElement()
      music.load()
    })
    function penMode() {
      music.play()
      canvasMode.value = 'pen'
      if (!context.value) {
        return
      }
      context.value.lineCap = 'round'
      context.value.lineJoin = 'round'
      context.value.lineWidth = 5
      context.value.strokeStyle = '#000000'
    }
    function eraserMode() {
      music.play()
      canvasMode.value = 'eraser'
      if (!context.value) {
        return
      }
      context.value.lineCap = 'square'
      context.value.lineWidth = 30
      context.value.strokeStyle = '#FFFFFF'
    }
    function mouseDraw(e: any): void {
      const x = e.layerX
      const y = e.layerY

      if (!isDrag.value) {
        return
      }
      if (!context.value) {
        return
      }

      context.value.lineTo(x, y)
      context.value.stroke()
    }
    function touchDraw(e: any): void {
      if (!canvas.value) {
        return
      }
      const paintRect = canvas.value.getBoundingClientRect()
      const x = e.targetTouches[0].pageX - (paintRect.left + window.pageXOffset)
      const y = e.targetTouches[0].pageY - (paintRect.top + window.pageYOffset)

      if (!isDrag.value) {
        return
      }
      if (!context.value) {
        return
      }

      context.value.lineTo(x, y)
      context.value.stroke()
    }
    function dragStart(e: any): void {
      if (!context.value) {
        return
      }
      const x = e.layerX
      const y = e.layerY
      context.value.beginPath()
      context.value.lineTo(x, y)
      context.value.stroke()
      isDrag.value = true
    }
    function touchStart(e: any): void {
      if (!context.value || !canvas.value) {
        return
      }
      const paintRect = canvas.value.getBoundingClientRect()
      const x = e.targetTouches[0].pageX - (paintRect.left + window.pageXOffset)
      const y = e.targetTouches[0].pageY - (paintRect.top + window.pageYOffset)
      context.value.beginPath()
      context.value.lineTo(x, y)
      context.value.stroke()
      isDrag.value = true
    }
    function dragEnd() {
      if (!context.value) {
        return
      }
      context.value.closePath()
      isDrag.value = false
    }

    function clear(): void {
      music.play()
      if (!context.value || !canvas.value) {
        return
      }
      context.value.clearRect(0, 0, canvas.value.width, canvas.value.height)
      isOverClearBtn.value = isOverClearBtn.value ? false : true
      setTimeout(() => {
        isOverClearBtn.value = isOverClearBtn.value ? false : true
      }, 100)
    }

    function resizeCanvas(w: number, h: number) {
      if (!canvas.value) {
        return
      }
      canvas.value.setAttribute('width', w.toString())
      canvas.value.setAttribute('height', h.toString())
    }

    return {
      root,
      resizeElement,
      mouseDraw,
      touchDraw,
      dragStart,
      touchStart,
      dragEnd,
      clear,
      canvasMode,
      penMode,
      eraserMode,
      resizeCanvas,
      isOverClearBtn,
    }
  },
})
